




import Vue from 'vue'

export default Vue.extend({
  name: 'NextButton',
  methods: {
    submit () {
      this.$emit('submit')
    }
  }
})
